module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_gold_de-ede7524728aa5a030f7778afb2b5a8bd.png";